import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import App from "./App.tsx";
import "./index.css";
import "./i18n.ts";
import i18n from "./i18n.ts";
import { captureAttributionFromUrl } from "./lib/attribution";
import { initGoogleAnalytics } from "./lib/ga";

// First-Touch: gclid/utm_* aus URL in sessionStorage festhalten (vor Consent).
captureAttributionFromUrl();

// Google Analytics: consent-gated, lädt erst nach Cookie-Accept.
initGoogleAnalytics();

createRoot(document.getElementById("root")!).render(
  <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>
);
